/**
 * Internal Audit Routes
 *
 * This file defines the routes for the Internal Audit domain.
 */

/**
 * Routes for the Internal Audit domain
 */
export const routes = {
  internalAudit: {
    // Community-scoped audit routes
    community: {
      audits: (communityId: string) => `/communities/${communityId}/audits`,
      auditDetail: (communityId: string, sessionId: string) => `/communities/${communityId}/audits/${sessionId}`,
      auditSession: (communityId: string, sessionId: string) => `/communities/${communityId}/audits/${sessionId}/audit`,
    },
    // Legacy global routes (deprecated - will be removed)
    root: '/internal-audit',
    sessions: {
      root: '/internal-audit/sessions',
      detail: (sessionId: string) => `/internal-audit/sessions/${sessionId}`,
      audit: (sessionId: string) => `/internal-audit/sessions/${sessionId}/audit`,
    },
    reports: {
      root: '/internal-audit/reports',
      create: '/internal-audit/reports/create',
      detail: (reportId: string) => `/internal-audit/reports/${reportId}`,
    },
  },
};
